import * as IsActive from '../../../components/is_active'
export * from '../constants'

export const FETCH_TODAY_ISSUES = 'FETCH_TODAY_ISSUES'
export const FETCH_TODAY_ACTIONS = 'FETCH_TODAY_ACTIONS'

export const SELECT_TODAY_DATE = 'SELECT_TODAY_DATE'

export const RESUBMIT_ISSUE = 'RESUBMIT_ISSUE'

export const SERVER_RESOURCE = '/newsbriefs'
export const SERVER_SUBJECT_LINE_RESOURCE = '/subject_lines'

export const CLICK_EVENT = 'click'
export const OPEN_EVENT = 'open'

export const actionEvent = (eventName: string): string => `FETCH_TODAY_${eventName}`

export const FETCH_TODAY_OPENS = actionEvent(OPEN_EVENT)
export const FETCH_TODAY_CLICKS = actionEvent(CLICK_EVENT)

export const FETCH_TODAY_SUBJECT_LINES = 'FETCH_TODAY_SUBJECT_LINES'
export const HOURLY_COUNT = 'hourly_count'

export const DATE_SELECT_TODAY_MODE = 'today'
export const DATE_SELECT_YESTERDAY_MODE = 'yesterday'
export const DATE_SELECT_LASTWEEK_MODE = 'lastweek'
export const DATE_SELECT_CUSTOM_MODE = 'custom'

export const UPDATE_SELECTED_DATE = `${IsActive.UPDATE_SELECTED_DATE}`

export const CHANGE_DATE_SELECT = 'CHANGE_DATE_SELECT'

export const DATE_SELECT_TODAY: IsActive.Filter = {
    description: 'Today',
    key: 'mode',
    value: DATE_SELECT_TODAY_MODE,
  }

export const DATE_SELECT_YESTERDAY: IsActive.Filter = {
  description: 'Yesterday',
  key: 'mode',
  value: DATE_SELECT_YESTERDAY_MODE,
}

export const DATE_SELECT_LASTWEEK: IsActive.Filter = {
  description: 'Last Week',
  key: 'mode',
  value: DATE_SELECT_LASTWEEK_MODE,
}

export const DATE_SELECT_CUSTOM: IsActive.Filter = {
  description: 'Pick a date',
  key: 'mode',
  value: DATE_SELECT_CUSTOM_MODE,
}

export const dateSelectFilters = [DATE_SELECT_TODAY, DATE_SELECT_YESTERDAY, DATE_SELECT_LASTWEEK, DATE_SELECT_CUSTOM]



// WEBPACK FOOTER //
// ./src/pages/reports/today/constants.ts